import React, { useEffect, useState } from "react";
import { Link } from "@reach/router";

const Posts = () => {
  const [posts, setPosts] = useState([
    { id: 1, title: "first post", published_at: new Date(), text: "first post for cloudflare" },
    { id: 2, title: "second post", published_at: new Date(), text: "second post for cloudflare" },
    { id: 3, title: "third post", published_at: new Date(), text: "third post for cloudflare" }
]);

  useEffect(() => {
    const getPosts = async () => {
      const resp = await fetch(
        "https://assignment.koteswar-meesala.workers.dev/"
      );
      const postsResp = await resp.json();
      setPosts(postsResp);
    };

    getPosts();
  }, []);

  return (
    <div>
      <h1>Posts</h1>
      {posts.map((post) => (
        <div key={post.id}>
          <h2>
            <Link to={`/posts/${post.title}/${post.published_at}`}>{post.title}</Link>
          </h2>
        </div>
      ))}
    </div>
  );
};

export default Posts;